import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LinkComponent, NavTarget } from '../../../../shared/components/link/link.component';
import { GrundstuecknummerPipe } from '../../../../shared/pipes/simple/grundstuecknummer.pipe';
import { KompaktGrundstueckPipe } from '../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { GrundstueckListEntry } from '../../../../core/gb-api';

@Component({
  selector: 'cap-gebaeude-list-grundstueck',
  templateUrl: './gebaeude-list-grundstueck.component.html',
  styleUrls: ['./gebaeude-list-grundstueck.component.scss'],
  imports: [LinkComponent, GrundstuecknummerPipe, KompaktGrundstueckPipe]
})
export class GebaeudeListGrundstueckComponent implements OnInit {
  grundstuecke: Array<GrundstueckListEntry>;

  navTargets = NavTarget;
  maxGrundstueckeProGebaeude = 3;

  @Input()
  set grundstueckList(value: Array<GrundstueckListEntry>) {
    this.grundstuecke = value;
  }

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}
}
